// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"e28d2470","955":"80dadda8"}[chunkId] + ".chunk.css";
};